import script from "./InterrailCards.vue?vue&type=script&lang=ts&setup=true"
export * from "./InterrailCards.vue?vue&type=script&lang=ts&setup=true"

import "./InterrailCards.vue?vue&type=style&index=0&id=18f0f21c&scoped=true&lang=css"

import exportComponent from "/Users/jnshul/Documents/tagluffa_i_vue3/main_page/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-18f0f21c"]])

export default __exports__